"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.TrendingSVG = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _Icon = require("../Icon");
var _excluded = ["children"];
var TrendingSVG = function TrendingSVG(_ref) {
  var children = _ref.children,
    rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/_react.default.createElement("path", {
    stroke: "none",
    d: "M28 8h-9a2 2 0 000 4h4.32L17 19l-5.5-6.32a2 2 0 00-1.43-.68 1.92 1.92 0 00-1.48.59l-6 6a2 2 0 002.82 2.82l4.49-4.48 5.6 6.39A2 2 0 0017 24a2 2 0 001.49-.66L26 15v4a2 2 0 004 0v-9a2 2 0 00-2-2z"
  }));
};
exports.TrendingSVG = TrendingSVG;
TrendingSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: _propTypes.default.node
} : {};
var _default = (0, _Icon.withIcon)(TrendingSVG);
exports.default = _default;